var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import { Validation, required, requiredIf, email, between, minLength, sameAs, regex, regexSet } from "../Decorators/validation.ts";
import { anyDirty } from "../Helpers/Vuelidate.ts";
import Cover from "../Components/Cover.vue";
import Wizard from "../Components/Wizard.vue";
import { SideNavPage } from "../Components/SideNav.ts";
import PersonalInformation from "./PersonalInformation.vue";
import Email from "./Email.vue";
import PostalAddress from "./PostalAddress.vue";
import PhoneNumber from "./PhoneNumber.vue";
import Experience from "./Experience.vue";
import LoginButtonList from "./LoginButtonList.vue";
import ChangePassword from "./ChangePassword.vue";
import { addDataUri } from "../Helpers/Image.ts";
import AlertList from "../Components/AlertList.vue";
import Alert from "bootstrap-vue/es/components/alert/alert";
var EditProfile = /** @class */ (function (_super) {
    __extends(EditProfile, _super);
    function EditProfile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localMetadata = _this.metadata;
        _this.localAvatarUrl = _this.avatarUrl || null;
        _this.localAvatarBytes = _this.avatarBytes ? addDataUri(_this.avatarBytes) : null;
        _this.localAvatarCrop = _this.avatarCrop || null;
        _this.localAvatarFileName = _this.avatarFileName || null;
        _this.localPrefix = _this.prefix || null;
        _this.localFirstName = _this.firstName || null;
        _this.localMiddleName = _this.middleName || null;
        _this.localLastName = _this.lastName || null;
        _this.localSuffix = _this.suffix || null;
        _this.localEmail = _this.email || null;
        _this.localAddressLine1 = _this.addressLine1 || null;
        _this.localAddressLine2 = _this.addressLine2 || null;
        _this.localAddressCity = _this.addressCity || null;
        _this.localAddressState = _this.addressState || null;
        _this.localAddressZip = _this.addressZip || null;
        _this.localPhoneNumber = _this.phoneNumber || null;
        _this.localStartYear = _this.startYear || null;
        _this.localGradeLevels = _this.gradeLevels;
        _this.localGradeLevelOther = _this.gradeLevelOther || null;
        _this.localPassword = _this.password || null;
        _this.localNewPassword = _this.newPassword || null;
        _this.localConfirmPassword = _this.confirmPassword || null;
        // HACK: Until vuelidate supports any dirty
        _this.anyDirty = anyDirty;
        return _this;
    }
    EditProfile.prototype.created = function () {
        // Set required validator that will be checked in controller so it is not in the metadata
        //
        if (!this.isEdit && !this.loginProvider) {
            this.localMetadata.newPassword.label = "Password";
            this.localMetadata.newPassword.validations.required = {
                errorMessage: "Password is required"
            };
        }
    };
    EditProfile.prototype.mounted = function () {
        var elms = this.$slots.csrf
            .map(function (p) { return p.elm; })
            .filter(function (p) { return p; })
            .map(function (p) { return p.outerHTML; })
            .filter(function (p) { return p; });
        var csrf = elms
            ? elms.reduce(function (acc, curr) { return "" + acc + curr; })
            : "<h1>Error obtaining CSRF Token.</h1>";
        if (this.$refs.linkedCsrf)
            this.$refs.linkedCsrf.outerHTML = csrf;
        if (this.$refs.additionalCsrf)
            this.$refs.additionalCsrf.outerHTML = csrf;
        if (this.$refs.existingCsrf)
            this.$refs.existingCsrf.outerHTML = csrf;
        if (this.$refs.possibleCsrf)
            this.$refs.possibleCsrf.outerHTML = csrf;
    };
    __decorate([
        Prop({ type: String, required: true })
    ], EditProfile.prototype, "formAction", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], EditProfile.prototype, "loginFormAction", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], EditProfile.prototype, "linkFormAction", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], EditProfile.prototype, "unlinkFormAction", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], EditProfile.prototype, "cancelUrl", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "finishText", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], EditProfile.prototype, "metadata", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], EditProfile.prototype, "title", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "description", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "avatarUrl", void 0);
    __decorate([
        Validation(),
        Validation({ group: "avatar" }),
        Validation({ group: "personalInformation" })
    ], EditProfile.prototype, "localAvatarUrl", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "avatarBytes", void 0);
    __decorate([
        Validation(),
        Validation({ group: "avatar" }),
        Validation({ group: "personalInformation" })
    ], EditProfile.prototype, "localAvatarBytes", void 0);
    __decorate([
        Prop({ type: Object })
    ], EditProfile.prototype, "avatarCrop", void 0);
    __decorate([
        Validation(),
        Validation({ group: "avatar" }),
        Validation({ group: "personalInformation" })
    ], EditProfile.prototype, "localAvatarCrop", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "avatarFileName", void 0);
    __decorate([
        Validation(),
        Validation({ group: "avatar" }),
        Validation({ group: "personalInformation" })
    ], EditProfile.prototype, "localAvatarFileName", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "prefix", void 0);
    __decorate([
        Validation(),
        Validation({ group: "name" }),
        Validation({ group: "personalInformation" })
    ], EditProfile.prototype, "localPrefix", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "firstName", void 0);
    __decorate([
        Validation({ required: required }),
        Validation({ group: "name" }),
        Validation({ group: "personalInformation" })
    ], EditProfile.prototype, "localFirstName", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "middleName", void 0);
    __decorate([
        Validation(),
        Validation({ group: "name" }),
        Validation({ group: "personalInformation" })
    ], EditProfile.prototype, "localMiddleName", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "lastName", void 0);
    __decorate([
        Validation({ required: required }),
        Validation({ group: "name" }),
        Validation({ group: "personalInformation" })
    ], EditProfile.prototype, "localLastName", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "suffix", void 0);
    __decorate([
        Validation(),
        Validation({ group: "name" }),
        Validation({ group: "personalInformation" })
    ], EditProfile.prototype, "localSuffix", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "email", void 0);
    __decorate([
        Validation({ required: required, emailAddress: email }),
        Validation({ group: "email" }),
        Validation({ group: "contact" })
    ], EditProfile.prototype, "localEmail", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "addressLine1", void 0);
    __decorate([
        Validation({ addressRequired: requiredIf(function () { return !!this.localAddressCity || !!this.localAddressState || !!this.localAddressZip; }) }),
        Validation({ group: "address" }),
        Validation({ group: "contact" })
    ], EditProfile.prototype, "localAddressLine1", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "addressLine2", void 0);
    __decorate([
        Validation(),
        Validation({ group: "address" }),
        Validation({ group: "contact" })
    ], EditProfile.prototype, "localAddressLine2", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "addressCity", void 0);
    __decorate([
        Validation({ addressRequired: requiredIf(function () { return !!this.localAddressLine1 || !!this.localAddressState || !!this.localAddressZip; }) }),
        Validation({ group: "address" }),
        Validation({ group: "contact" })
    ], EditProfile.prototype, "localAddressCity", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "addressState", void 0);
    __decorate([
        Validation({
            addressRequired: requiredIf(function () { return !!this.localAddressLine1 || !!this.localAddressCity || !!this.localAddressZip; }),
            regularExpression: regex(function () { return this.metadata.addressState.validations["regularExpression"].pattern; })
        }),
        Validation({ group: "address" }),
        Validation({ group: "contact" })
    ], EditProfile.prototype, "localAddressState", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "addressZip", void 0);
    __decorate([
        Validation({
            addressRequired: requiredIf(function () { return !!this.localAddressLine1 || !!this.localAddressCity || !!this.localAddressState; }),
            regularExpression: regex(function () { return this.metadata.addressZip.validations["regularExpression"].pattern; })
        }),
        Validation({ group: "address" }),
        Validation({ group: "contact" })
    ], EditProfile.prototype, "localAddressZip", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "phoneNumber", void 0);
    __decorate([
        Validation({ regularExpression: regex(function () { return this.metadata.phoneNumber.validations["regularExpression"].pattern; }) }),
        Validation({ group: "phone" }),
        Validation({ group: "contact" })
    ], EditProfile.prototype, "localPhoneNumber", void 0);
    __decorate([
        Prop({ type: Number })
    ], EditProfile.prototype, "startYear", void 0);
    __decorate([
        Validation({ rangeUntilThisYear: between(1969, new Date().getFullYear()) }),
        Validation({ group: "experience" })
    ], EditProfile.prototype, "localStartYear", void 0);
    __decorate([
        Prop({ type: Array, default: [] })
    ], EditProfile.prototype, "gradeLevels", void 0);
    __decorate([
        Validation(),
        Validation({ group: "experience" })
    ], EditProfile.prototype, "localGradeLevels", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "gradeLevelOther", void 0);
    __decorate([
        Validation(),
        Validation({ group: "experience" })
    ], EditProfile.prototype, "localGradeLevelOther", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], EditProfile.prototype, "linkedProviders", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], EditProfile.prototype, "isEdit", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], EditProfile.prototype, "hasExistingLogins", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], EditProfile.prototype, "existingLogins", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], EditProfile.prototype, "hasPossibleExistingLogins", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], EditProfile.prototype, "possibleExistingLogins", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "loginProvider", void 0);
    __decorate([
        Prop({ type: Boolean, required: true })
    ], EditProfile.prototype, "hasPassword", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "password", void 0);
    __decorate([
        Validation(),
        Validation({ group: "logins" }),
        Validation({ group: "password" })
    ], EditProfile.prototype, "localPassword", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "newPassword", void 0);
    __decorate([
        Validation({
            minLength: minLength(8),
            required: requiredIf(function () { return !this.isEdit && !this.loginProvider; }),
            requiredIfPresent: requiredIf(function () { return this.hasPassword && !!this.localPassword; }),
            regularExpressionSet: regexSet(function () { return this.metadata.newPassword.validations["regularExpressionSet"].patterns; }, function () { return this.metadata.newPassword.validations["regularExpressionSet"].minimum; })
        }),
        Validation({ group: "logins" }),
        Validation({ group: "password" })
    ], EditProfile.prototype, "localNewPassword", void 0);
    __decorate([
        Prop({ type: String })
    ], EditProfile.prototype, "confirmPassword", void 0);
    __decorate([
        Validation({
            compareIfPresent: sameAs(function () { return this.localNewPassword; })
        }),
        Validation({ group: "logins" }),
        Validation({ group: "password" })
    ], EditProfile.prototype, "localConfirmPassword", void 0);
    EditProfile = __decorate([
        Component({
            name: "EditProfile",
            components: {
                Cover: Cover,
                Wizard: Wizard,
                SideNavPage: SideNavPage,
                PersonalInformation: PersonalInformation,
                Email: Email,
                PostalAddress: PostalAddress,
                PhoneNumber: PhoneNumber,
                Experience: Experience,
                LoginButtonList: LoginButtonList,
                ChangePassword: ChangePassword,
                AlertList: AlertList,
                Alert: Alert
            }
        })
    ], EditProfile);
    return EditProfile;
}(Vue));
export default EditProfile;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Account/EditProfile.vue
// module id = 871
// module chunks = 6